import { render, staticRenderFns } from "./PromotionCoursesParticipantTable.vue?vue&type=template&id=2d4b1ab8"
import script from "./PromotionCoursesParticipantTable.vue?vue&type=script&lang=js"
export * from "./PromotionCoursesParticipantTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports